// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2r_CB","author":"Table_author__2PRVz","authorImage":"Table_authorImage__32frk","unreadRow":"Table_unreadRow__1HpOs"};